import { Dispatch, SetStateAction, useCallback } from 'react'
import { DatesType } from './types'

type UseDayClickHandler = {
  dates: DatesType
  setDates: Dispatch<SetStateAction<DatesType>>
  setEnteredTo: Dispatch<SetStateAction<Date | undefined>>
  onDayPickerHide: () => void
}

export const useDayClickHandler = ({
  dates,
  setDates,
  setEnteredTo,
  onDayPickerHide,
}: UseDayClickHandler) => {
  return useCallback(
    (selectedDate: Date) => {
      const { from, to } = dates

      if ((!from && !to) || (from && to)) {
        setDates({ from: selectedDate, to: undefined })
        return
      }

      if (from && !to) {
        if (from < selectedDate) {
          setDates({ from, to: selectedDate })
          setEnteredTo(undefined)
          onDayPickerHide()
          return
        }
        if (from > selectedDate) {
          setDates({ from: selectedDate, to: from })
          setEnteredTo(undefined)
          onDayPickerHide()
          return
        }
      }

      if (!from && to) {
        if (to < selectedDate) {
          setDates({ from: to, to: selectedDate })
          setEnteredTo(undefined)
          onDayPickerHide()
          return
        }
        if (to > selectedDate) {
          setDates({ from: selectedDate, to })
          setEnteredTo(undefined)
          onDayPickerHide()
          return
        }
      }
    },
    [dates, onDayPickerHide, setDates, setEnteredTo],
  )
}
